import { extend } from 'vee-validate';
import {
  required,
  max,
  between,
  min,
} from 'vee-validate/dist/rules';

extend('required', {
  ...required,
  message: '{_field_} cannot be empty',
});

extend('max', {
  ...max,
  message: '{_field_} cannot be longer than {length} characters',
});

extend('min', {
  ...min,
  message: '{_field_} must be longer than {length} characters',
});


extend('between', {
  ...between,
  params: ['min', 'max'],
  message: '{_field_} must be between {min} and {max}',
});

extend('password', {
  validate: (value) => {
    const pattern = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{8,})/; // eslint-disable-line no-useless-escape
    return pattern.test(value);
  },
  message: 'Min. 8 characters with at least one capital letter, a number and a special character.',
});

extend('file_type_pdf', {
  validate: (value) => {
    if (value.type !== 'application/pdf') return false;
    return true;
  },
  message: 'File type invalid. File must be of type PDF (.pdf)',
});

extend('file_size', {
  params: ['maxSize'],
  validate: (value, { maxSize }) => {
    const fileSize = value.size;
    if (fileSize > maxSize) return false;
    return true;
  },
  message: 'File size too large. Max file size is 10MB',
});
